<template>
  <zj-layout-container>
    <zj-layout-main>
      <el-form :model="viewData" class="zj-search-form" :disabled="true">
        <el-form-item label="事件名称：" style="display:inline-block;">
          <el-input
            v-model="viewData.EventName"
            style="width: 23rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件编号：" style="display:inline-block;">
          <el-input v-model="viewData.EventNo" style="width: 23rem"></el-input>
        </el-form-item>
        <el-form-item label="事件级别：" style="display:inline-block;">
          <el-select v-model="viewData.ConfirmEventLevel" style="width: 23rem">
            <el-option
              v-for="item in EventLevelOptions"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件类型：" style="display:inline-block;">
          <el-select v-model="viewData.ConfirmEventType" style="width: 23rem">
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事发地点：" style="display:inline-block;">
          <el-input
            v-model="viewData.EventLocation"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <el-form-item label="事发时间：" style="display:inline-block;">
          <el-date-picker
            style="width: 23rem"
            type="datetime"
            placeholder="选择日期"
            v-model="viewData.EventDate"
            :disabled="EventInfoEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上报人姓名：" style="display:inline-block;">
          <el-input
            v-model="viewData.ReporterName"
            style="width: 21.5rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件描述：" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="viewData.EventContent"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <div style="width: 100%;height: 0; border-top: 1px solid #eee;"></div>
      </el-form>
      <el-form :model="viewData" class="zj-search-form">
        <el-form-item
          label="总结说明："
          style="display:inline-block;margin-top:2rem"
        >
          <el-input
            type="textarea"
            v-model="viewData.SummaryDesc"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
        <el-form-item label="归档描述：" style="display:inline-block;">
          <el-input
            type="textarea"
            v-model="viewData.FileDesc"
            style="width: 57rem;"
          ></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer style="text-align:center;">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm()">确定</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import MyApis from "../../../apis";
export default {
  data() {
    return {
      EventTypeOptions: [],
      EventLevelOptions: [],
    };
  },
  props: {
    viewData: Object,
  },
  methods: {
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      this.viewData.Status = 7;
      new MyApis.EmergencyEventApi()
        .UpdateItem(this.viewData)
        .then((r) => {
          r = r.data.Data;
          this.$emit("search", {});
          this.$emit("ok", {});
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.logInfo.ActionName = "应急事件归档";
          this.logInfo.LogMessage = r ? "应急事件归档成功" : "应急事件归档失败";
          this.logInfo.ModuleName = "应急系统";
          this.logInfo.PageName = "应急事件归档信息";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
  created: function() {
    this.config
      .getUValue("EmergencyService:FitEventType", "")
      .then((eventtypeconf) => {
        this.EventTypeOptions = eventtypeconf.JValue;
      })
      .catch((e) => {
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });

    this.config
      .getUValue("EmergencyService:EmergencyEventLevel", "")
      .then((eventlevelconf) => {
        this.EventLevelOptions = eventlevelconf.JValue;
      })
      .catch((e) => {
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });
  },
};
</script>
